module.exports = __webpack_public_path__ + "img/cart.07b34072.png";